import React, { useEffect, useState } from "react";
import {
  Typography,
  Button,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { FeatureResponse, EditFeatureRequest } from "../../../services/models";
import apiClient from "../../../utils/api";
import { DataGrid, GridColDef } from "@mui/x-data-grid";

const ListAllFeatures: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [selectedFeature, setSelectedFeature] =
    useState<FeatureResponse | null>(null);
  const [newValidUntil, setNewValidUntil] = useState<string | null>("");
  const [removeValidUntil, setRemoveValidUntil] = useState(false);
  const [allFeatures, setAllFeatures] = useState<FeatureResponse[]>([]);

  const fetchAllFeatures = async () => {
    const features = await apiClient.featureFlagsControllerListAllFeatures();
    console.log("features", features);
    setAllFeatures(features);
  };

  useEffect(() => {
    fetchAllFeatures();
  }, []);

  const handleClickOpen = (feature: FeatureResponse) => {
    setSelectedFeature(feature);
    setNewValidUntil(
      feature.validUntil
        ? new Date(feature.validUntil).toISOString().slice(0, -1)
        : ""
    );
    setRemoveValidUntil(false);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedFeature(null);
    setNewValidUntil("");
    setRemoveValidUntil(false);
  };

  const handleSave = async () => {
    if (selectedFeature) {
      const request: EditFeatureRequest = {
        featureName: selectedFeature.featureName,
        targetId: selectedFeature.targetId,
        validUntil: removeValidUntil
          ? null
          : newValidUntil
          ? new Date(newValidUntil)
          : undefined,
      };
      if (selectedFeature.targetType === "user") {
        await apiClient.featureFlagsControllerEditUserFeature({
          editFeatureRequest: request,
        });
      }
      if (selectedFeature.targetType === "class") {
        await apiClient.featureFlagsControllerEditClassFeature({
          editFeatureRequest: request,
        });
      }
      fetchAllFeatures();
      handleClose();
    }
  };

  const columns: GridColDef<FeatureResponse>[] = [
    {
      field: "targetId",
      headerName: "Target ID",
      width: 200,
    },
    {
      field: "targetType",
      headerName: "Target Type",
      width: 200,
    },
    {
      field: "featureName",
      headerName: "Feature Name",
      width: 200,
      valueGetter: (value, row) => row.featureName,
    },
    {
      field: "validUntil",
      headerName: "Valid Until",
      width: 200,
      valueGetter: (value, row) =>
        row.validUntil ? new Date(row.validUntil).toLocaleString() : "Always",
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 200,
      renderCell: (params: any) => (
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleClickOpen(params.row)}
        >
          Edit
        </Button>
      ),
    },
  ];

  console.log("allFeatures", allFeatures);

  return (
    <Grid item xs={12}>
      <Typography variant="h6">All Available Features</Typography>
      <Button variant="contained" color="secondary" onClick={fetchAllFeatures}>
        Fetch All Features
      </Button>
      <DataGrid
        rows={allFeatures}
        columns={columns}
        getRowId={(row) => `${row.targetId}-${row.featureName}`}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 5,
            },
          },
        }}
        pageSizeOptions={[5]}
      />
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Edit Valid Until Date</DialogTitle>
        <DialogContent>
          <DialogContentText>
            To update the valid until date, please enter the new date and time
            below.
          </DialogContentText>
          <TextField
            label="Valid Until"
            type="datetime-local"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={newValidUntil || ""}
            onChange={(e) => setNewValidUntil(e.target.value)}
            disabled={removeValidUntil}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={removeValidUntil}
                onChange={(e) => setRemoveValidUntil(e.target.checked)}
              />
            }
            label="Remove Valid Until"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleSave} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default ListAllFeatures;
